// JsFromRoutes CacheKey 157f50e2710d2e838416ab071e931037
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/shortcuts/ai_settings'),
  scan: /* #__PURE__ */ definePathHelper('post', '/:account_id/shortcuts/ai_scan'),
}
